import React from 'react';
import ReactExport from 'react-data-export';
import {Button} from '@material-ui/core';
import jMoment from 'moment-jalaali';
import RonadIcons from '../../components/iconComponent';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

interface Props {
  loading: boolean;
  data: any;
  handleRequest: any;
  filtersValues: any;
}

const ExelExport = ({loading, data, handleRequest, filtersValues}: Props) => {
  const handleCreateExel = () => {
    handleRequest({...filtersValues, page: 0, size: 10000});
  };

  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      let featureList = '';
      if (item.features) {
        for (let i = 0; i <= 2 && item.features[i]; i++) {
          featureList = featureList.concat(
            ' - ',
            item.features[i].key,
            ' : ',
            item.features[i].value
          );
        }
      }

      return {
        ...item,
        features: item.features ? featureList : undefined,
        date: item.date
          ? jMoment(item.date, 'YYYY/MM/DD')
              .locale('fa')
              .format('jYYYY/jMM/jDD')
          : undefined,
      };
    });
    return newData;
  };

  if (data.length > 0) {
    return (
      <ExcelFile
        element={
          <Button
            style={{marginLeft: '5px', padding: '10px 20px'}}
            variant="outlined"
            color="primary"
          >
            <RonadIcons name='download' size={.7} className='text-primary' style={{marginTop: "-4px"}}/>
            EXCEL
          </Button>
        }
      >
        <ExcelSheet data={flattData(data)} name="orders">
          {data &&
            Object.entries(flattData(data)[0])?.map(el => {
              return <ExcelColumn label={el[0]} value={el[0]} />;
            })}
        </ExcelSheet>
      </ExcelFile>
    );
  } else {
    return (
      <Button
        style={{marginLeft: '5px'}}
        variant="outlined"
        color="primary"
        startIcon={<RonadIcons name='plus' size={.6} className='text-primary' style={{marginTop: "-4px"}}/>}
        onClick={handleCreateExel}
        disabled={loading}
      >
        EXCEL
      </Button>
    );
  }
};

export default ExelExport;
